"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimplePercent = void 0;
const react_1 = __importDefault(require("react"));
const SimplePercent = ({ size, color }) => {
    return (react_1.default.createElement("svg", { width: size, height: size, viewBox: "0 0 54 54", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("rect", { x: "42.669", y: "1", width: "8.55", height: "56.1", rx: "4.275", transform: "rotate(45 42.669 1)", fill: color || '#25CFBB' }),
        react_1.default.createElement("circle", { cx: "13", cy: "11", r: "5", fill: color || '#25CFBB' }),
        react_1.default.createElement("circle", { cx: "39", cy: "37", r: "5", fill: color || '#25CFBB' })));
};
exports.SimplePercent = SimplePercent;
